import { prependModuleName } from '@/utils/vueUtils';
const hubDailyReportMutationList = {
    SET_REPORT_TYPE: 'SET_REPORT_TYPE',
    SET_DETAIL_DATE: 'SET_DETAIL_DATE',
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    SET_KEYWORD: 'SET_KEYWORD',
    SET_SEARCH_TYPE: 'SET_SEARCH_TYPE',
    RESET_FILTER_OPTIONS: 'RESET_FILTER_OPTIONS',
    GET_HUB_DAILY_REPORT: 'GET_HUB_DAILY_REPORT',
    RESET_HUB_DAILY_REPORT: 'RESET_HUB_DAILY_REPORT',
};
const hubDailyReportActionTypeList = {
    setReportType: 'setReportType',
    setDetailDate: 'setDetailDate',
    setFilterOption: 'setFilterOption',
    setKeyword: 'setKeyword',
    setSearchType: 'setSearchType',
    resetFilterOptions: 'resetFilterOptions',
    getHubDailyReport: 'getHubDailyReport',
    resetHubDailyReport: 'resetHubDailyReport',
};
const hubDailyReportActionTypePath = prependModuleName('hubAdjustment/hubDailyReport', hubDailyReportActionTypeList);
export { hubDailyReportMutationList, hubDailyReportActionTypeList, hubDailyReportActionTypePath, };
